import { useEffect, useState } from "react";
import { loadLibraryData, makeListData } from "../../../master/libraryData";
import { Modal } from "../../../components/Modal";
import { HexList } from "../../../components/HexList";
import { TextField } from "@mui/material";

interface LibraryModalProps<t> {
    show: boolean;
    prefix: string;
    title: string;
    defaultItem: t;
    onClose: () => void;
    onSelect: (item: t) => void;
}

const LibraryModal = <T,>(props: LibraryModalProps<T>) => {
    const { show, title, prefix, defaultItem, onClose, onSelect } = props;
    const [ searchTerm, setSearchTerm ] = useState("");
    
    useEffect(() => { setSearchTerm("")}, [props.show]);

    const handleSelectItem = (id: string) => {
            if(id !== "_custom"){
                const data = loadLibraryData<T>(prefix, id ?? "NONE");
                if(data !== undefined)
                    onSelect(data);
            } else {
                onSelect(defaultItem);
            }
            onClose();
        }
    
    const itemList = makeListData(prefix, handleSelectItem);

    const actions = [
            {
                label: "Cancel",    
                onClick: props.onClose,
                size:12
            }
        ];

    return <Modal title={title} actions={actions} onClose={onClose} open={show}>
        <TextField fullWidth
            placeholder="Search"
            type="text" 
            variant="standard"
            value={searchTerm}
            style={{marginBottom: 1}}
            onChange={(event) => setSearchTerm(event.currentTarget.value)} />
        <HexList
            items={itemList.filter((item) => searchTerm === "" || item.name.toLowerCase().includes(searchTerm.toLowerCase()))}
            />
    </Modal>
    }

    export default LibraryModal;